<template>
	<div>
		<AppButton
			:label="$t('reports.export-log')"
			secondary
			variant="gray"
			startIcon="assets/v2/image/icons/excel.svg"
			class="rtl:tw-flex-row-reverse"
			size="lg"
			@click="exportExcel"
		/>
	</div>
</template>

<script setup>
import { useTableStore } from '@/v2/store/shared/table-store';
import { ReportsModuleService } from '../../../service';
import { t } from '@/locales/index';
import { Alert } from '@/v2/plugins/alert';

const tableStore = useTableStore({
	tableName: 'activityLog',
	fetchDataFunction: ReportsModuleService.getActivityLog,
});

const exportExcel = () => {
	tableStore.exportData('xlsx');
	Alert.success(t('export-started-msg'));
};
</script>
